import type { PublicHelpCatalog } from './public-help';
import { publicGuideHref } from './public-help';

export interface WorkspaceSearchOption {
  label: string;
  to: string;
  section: string;
  external?: boolean;
}
interface Topic {
  id: string;
  title: string;
  description: string;
  keywords: string;
}
const filler = new Set([
  'how',
  'to',
  'do',
  'i',
  'a',
  'an',
  'the',
  'can',
  'my',
  'please',
  'help',
  'with',
  'in',
  'is',
]);
export function workspaceHelpResults(
  text: string,
  catalog: PublicHelpCatalog,
  topics: Topic[],
  helpUrl: string,
): WorkspaceSearchOption[] {
  const query = text.trim();
  if (!query) return [{ label: 'Help Center', to: `${helpUrl}/`, section: 'Help Center', external: true }];
  const terms = query
    .toLowerCase()
    .split(/[^\p{L}\p{N}]+/u)
    .filter((t) => t && !filler.has(t));
  const matches = (item: Topic) =>
    terms.every((term) => `${item.title} ${item.description} ${item.keywords}`.toLowerCase().includes(term));
  const score = (item: Topic) => terms.filter((term) => item.title.toLowerCase().includes(term)).length;
  const guides: WorkspaceSearchOption[] = catalog.guides
    .filter(matches)
    .sort((a, b) => score(b) - score(a))
    .slice(0, 5)
    .map((g) => ({
      label: g.title,
      to: publicGuideHref(helpUrl, g.id),
      section: 'Help Center',
      external: true,
    }));
  const troubleshooting: WorkspaceSearchOption[] = terms.length
    ? topics
        .filter(matches)
        .sort((a, b) => score(b) - score(a))
        .slice(0, 3)
        .map((t) => ({
          label: t.title,
          to: `/help?topic=${encodeURIComponent(t.id)}`,
          section: 'Guided troubleshooting',
        }))
    : [];
  return [
    ...new Map(
      [
        ...guides,
        ...troubleshooting,
        {
          label: `Search Help Center for “${query}”`,
          to: `${helpUrl}/?q=${encodeURIComponent(query)}`,
          section: 'Help Center',
          external: true,
        },
      ].map((result) => [result.to, result]),
    ).values(),
  ];
}
